import { ReferralPaymentStatus, UserRole } from "@/types";
import {
  formatUserRoleToName,
  getDisplayFilters,
  keepObjectWithKeys,
} from "@/utils";
import { Button, Chip, Stack } from "@mui/material";
import { FC } from "react";
import { useListContext } from "react-admin";
import { ReferralUsersListFilter } from "../../types";

const FiltersList: FC = () => {
  const { filterValues, setFilters } = useListContext();

  const displayFilters = getDisplayFilters<ReferralUsersListFilter>(
    filterValues,
    {
      paymentStatuses: {
        [ReferralPaymentStatus.PAID]: "Paid",
        [ReferralPaymentStatus.UNPAID]: "Unpaid",
      },
      roles: {
        [UserRole.ALPHA]: formatUserRoleToName(UserRole.ALPHA),
        [UserRole.MUSE]: formatUserRoleToName(UserRole.MUSE),
      },
    },
    setFilters
  );

  return (
    <Stack direction={"row"} spacing={0.5} alignItems={"center"}>
      {displayFilters.map(({ id, label, onDelete }) => (
        <Chip
          key={id}
          size="small"
          variant="filled"
          label={label}
          onClick={onDelete}
          onDelete={onDelete}
        />
      ))}
      {!!Object.values(
        keepObjectWithKeys(filterValues as ReferralUsersListFilter, [
          "paymentStatuses",
          "roles",
        ])
      ).length && (
        <Button
          size="small"
          variant="outlined"
          onClick={() => setFilters({}, [])}
        >
          Clear All
        </Button>
      )}
    </Stack>
  );
};

export { FiltersList };
